export default {
  path: '/sale',
  title: '易销售',
  icon: 'try',
  children: [
    {
      path: 'order/bulkOrder',
      title: '大货订单',
      icon: 'file-text',
      component: 'sale/order/bulkOrder'
    }
  ]
}
